import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import UploadButton from '../UploadButton';

const DragHandle = SortableHandle(props => {
    return (
        <div className="drag-point">
            <i className="fas fa-sort"></i>
        </div>
    );

})

const Sortable = SortableElement(props => {
    return (
        <div className="sortable-item d-flex col-4">
            <div className="d-flex">
                <div>
                    <DragHandle {...props} />
                    <div className="delete-point" index={props.itemIndex} onClick={props.deleteButtonHandler}>
                        <i className="far fa-trash-alt"></i>
                    </div>
                </div>
                <div>
                    <div className="col-6 d-flex">
                        <div>
                            <label>Изображение</label>
                            <div className="images">
                                <div className="img-container">
                                    <div className="img-wrap">
                                        <img src={props.element}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pt-3">
                            <UploadButton name={`brands.${props.itemIndex}`} index={props.itemIndex} onChange={props.onChange}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Sortable;
